<template>
  <transition name="drop-down">
    <div
      v-show="expanded"
      @keydown="handleTabKey"
      :aria-hidden="(!expanded).toString()"
      @mouseleave="expand"
      :class="{ loaded: loaded }"
    >
      <slot />
    </div>
  </transition>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  data() {
    return {
      expanded: false,
      loaded: false,
      focusable: Object,
    }
  },
  props: {
    section: {
      type: String,
    },
  },
  methods: {
    expandMaybe(linkExpanded) {
      // prevent flashing by ignoring event when transitioning
      // eslint-disable-next-line
      if (!(this.$el.classList.contains('drop-down-enter') || this.$el.classList.contains('drop-down-leave-to'))) {
        this.expanded = linkExpanded
      }
    },
    handleEsc(event) {
      if (event.keyCode === 27) {
        if (this.expanded) {
          this.expanded == false
          eventBus.$emit('nav:desktop:' + this.section + ':collapse', 'single')
        }
      }
    },
    focusFirst() {
      if (this.expanded) {
        const focusable = this.$el.querySelectorAll('button, [href]')
        focusable[0].focus()
      }
    },
    focusLast() {
      if (this.expanded) {
        const focusable = this.$el.querySelectorAll('button, [href]')
        focusable[focusable.length - 1].focus()
      }
    },
    handleTabKey(event) {
      if (this.expanded) {
        const focusable = this.$el.querySelectorAll('button, [href]')
        /* if (focusable[0] == document.activeElement && event.shiftKey) {
          event.preventDefault()
          eventBus.$emit('nav:desktop:' + this.section + ':focus')
        } */
        if (
          focusable[focusable.length - 1] == document.activeElement &&
          !event.shiftKey
        ) {
          eventBus.$emit('nav:desktop:' + this.section + ':collapse')
        }
      }
    },
    expand() {
      this.$parent.mouseIsOver = true
      this.$emit('expand', false)
    },
  },
  mounted() {
    eventBus.$on('nav:desktop:' + this.section, this.expandMaybe)
    eventBus.$on('select:menu:first', this.focusFirst)
    eventBus.$on('select:menu:last', this.focusLast)
    window.addEventListener('keyup', this.handleEsc)

    this.$nextTick(() => {
      this.loaded = true
    })
  },
}
</script>

<style lang="scss" scoped>
.drop-down-enter-active,
.drop-down-leave-active {
  transition: all 0.25s ease-in;
}

.drop-down-enter,
.drop-down-leave-to {
  transform: translateY(-25px);
  opacity: 0;
}
</style>
